import React, { Suspense, lazy } from 'react';
import { Helmet } from 'react-helmet';
import { Box } from '@mui/material';
import FAQHomepage from './Homepage/FAQHomepage';

const HeroBanner = lazy(() => import('../pages/Homepage/HeroBanner'));
const Editais = lazy(() => import('../pages/Homepage/Editais'));
const Cursos = lazy(() => import('../pages/Homepage/Cursos'));
const NoticiasAgenda = lazy(() => import('../pages/Homepage/NoticiasAgenda'));
const Contato = lazy(() => import('../pages/Homepage/Contato'));

const Homepage: React.FC = () => {
  return (
    <Box component="main" sx={{ backgroundColor: '#fff', width: '100%' }}>
      <Helmet>
        <title>Faculdade SENAC - Ensino Superior de Qualidade</title>
        <meta
          name="description"
          content="Conheça nossos cursos de Graduação, Pós-Graduação e participe do Vestibular."
        />
      </Helmet>
      <Suspense fallback={<Box textAlign="center" py={4}>Carregando...</Box>}>
        <HeroBanner />
        <Cursos />
        <Editais />
        <NoticiasAgenda />
        <FAQHomepage />
        <Contato />
      </Suspense>
    </Box>
  );
};

export default Homepage;
